module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline grey lighten-4 py-0"
  }, [_vm._v("\n    Assign appointment types to this location\n    ("), _c('strong', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.location.name))]), _vm._v(")\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.setproducts
    },
    on: {
      "ok": function($event) {
        return _vm.$emit("close")
      }
    }
  }), _vm._v(" "), _c('v-card-text', [_vm._l((_vm.products), function(product) {
    return [_c('v-checkbox', {
      key: product.id,
      staticClass: "caption",
      attrs: {
        "hide-details": "",
        "value": product.id,
        "label": product.title
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "loading": _vm.setproducts.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Set Appointment Types")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d2cc187","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/LocationAssign.vue
// module id = 1397
// module chunks = 9